<template>
    <div class="user-shipment">
        <div
            class="font-apercu-bold is-size-4"
            style="margin-bottom: 60px; display: flex"
        >
            <h6 style="margin: 0 10px">{{ $t("Orders") }}</h6>

            <router-link
                class="mobile-send-shipment button"
                style="margin: 0 10px"
                :to="{ name: 'send-shipment' }"
            >
                {{ $t("Send Shipment") }}
            </router-link>
        </div>

        <div style="padding: 0" class="table" id="main-card">
            <div class="card-head">
                <div class="l-sec">
                    <input
                        v-model="search"
                        type="text"
                        :placeholder="$t('Search with order number')"
                    />
                </div>
                <div class="r-sec">
                    <export-excel
                        :title="$t('ALKOON MY Shipment')"
                        class="btn btn-default"
                        :fields="json_fields"
                        :data="shipments"
                        worksheet="ALKOON MY shipments"
                        name="ALKOON_MY_shipment.xls"
                    >
                        <button class="button">{{ $t("Export") }}</button>
                    </export-excel>
                    <button
                        style="width: 200px"
                        class="button"
                        v-if="orders.length > 1"
                        @click="isPickupOpen = true"
                    >
                        {{ $t("Groub pickup") }}
                    </button>
                </div>
            </div>
            <div class="card-head">
                <div class="filter-sec">
                    <span>{{ $t("Status") }}:</span>
                    <b-select
                        v-model="filter.status"
                        :placeholder="$t('Choose status')"
                        style="width: 200px; margin: 0 10px"
                    >
                        <option selected :value="0">
                            {{ $t("View all") }}
                        </option>
                        <option :value="1">{{ $t("Draft") }}</option>
                        <option :value="2">{{ $t("Reviewing") }}</option>
                        <option :value="4">{{ $t("In-transit") }}</option>
                        <option :value="13">{{ $t("Waiting Pick-up") }}</option>
                        <option :value="10">{{ $t("Delivered") }}</option>
                        <option :value="11">{{ $t("Canceled") }}</option>
                    </b-select>
                </div>
                <div class="filter-sec">
                    <span>{{ $t("Vendor name") }}:</span>
                    <b-select
                        v-model="filter.vendor"
                        :placeholder="$t('Choose vendor name')"
                        style="width: 200px; margin: 0 10px"
                    >
                        <option selected :value="0">
                            {{ $t("View all") }}
                        </option>
                        <option value="DHL">DHL</option>
                        <option value="FedEx">FedEx</option>
                        <option value="UPS">UPS</option>
                    </b-select>
                </div>
                <div class="filter-sec">
                    <b-checkbox
                        v-model="filter.is_archived"
                        :true-value="1"
                        :false-value="0"
                    >
                        {{ $t("Show archived shipment") }}
                    </b-checkbox>
                </div>
            </div>
            <b-table
                v-if="shipments && shipments.length"
                :loading="loading"
                :pagination-simple="false"
                pagination-size="is-small"
                :total="total"
                detailed
                checkable
                :checked-rows.sync="checkedRows"
                :paginated="true"
                backend-pagination
                :per-page="perPage"
                @page-change="filterShipment($event)"
                :data="filterdShipment"
            >
                <template slot-scope="props">
                    <b-table-column field="track" :label="$t('Order number')">
                        <div class="td-spacer">
                            <div class="areas">
                                <div class="name">
                                    {{ props.row.order_number }}
                                </div>
                            </div>
                        </div>
                    </b-table-column>
                    <b-table-column field="track" :label="$t('Date')">
                        <div class="td-spacer">
                            <div class="areas">
                                <div class="name">
                                    {{
                                        props.row.created_at
                                            | moment("DD-MM-YYYY")
                                    }}
                                </div>
                            </div>
                        </div>
                    </b-table-column>
                    <b-table-column
                        field="vendor_name"
                        :label="$t('Service Provider')"
                        centered
                    >
                        <div class="level">
                            <div class="level-item">
                                <span>{{ props.row.vendor_name }}</span>
                            </div>
                        </div>
                    </b-table-column>
                    <b-table-column
                        field="vendor_name"
                        :label="$t('Tracking Number')"
                        centered
                    >
                        <div class="level">
                            <div class="level-item">
                                <span>{{
                                    props.row.vendor_shipment_id || "-"
                                }}</span>
                            </div>
                        </div>
                    </b-table-column>
                    <b-table-column
                        field="total_weight"
                        :label="$t('Total Weight')"
                        centered
                    >
                        <div class="level">
                            <div class="level-item">
                                <span>
                                    {{
                                        props.row.total_weight | number("0,0.0")
                                    }}
                                    {{ $t("KG") }}
                                </span>
                            </div>
                        </div>
                    </b-table-column>
                    <b-table-column
                        field="total_price"
                        :label="$t('Amount')"
                        centered
                    >
                        <div class="level">
                            <div class="level-item" style="flex-flow: wrap">
                                <span
                                    style="
                                        color: #4952ff;
                                        display: block;
                                        width: 100%;
                                    "
                                >
                                    {{
                                        props.row.total_price | number("0,0.00")
                                    }}
                                    {{ $t("SAR") }}
                                </span>
                                <span
                                    v-if="props.row.origin.country_id == 226"
                                    style="
                                        color: #777;
                                        display: block;
                                        width: 100%;
                                        font-size: 12px;
                                    "
                                >
                                    {{
                                        (props.row.total_price / 3.75)
                                            | number("0,0.00")
                                    }}
                                    $
                                </span>
                            </div>
                        </div>
                    </b-table-column>

                    <b-table-column
                        field="status"
                        :label="$t('Status')"
                        centered
                    >
                        <div class="level">
                            <div class="level-item">
                                <span
                                    :class="
                                        'status st-' + props.row.status.label
                                    "
                                    >{{ $t(props.row.status.label) }}</span
                                >
                            </div>
                        </div>
                    </b-table-column>

                    <b-table-column field="actions" style="width: 50px">
                        <div v-if="props.row.is_archived" class="level">
                            <div class="msg" v-if="props.row.is_invoiced">
                                <p>{{ $t("paid") }}</p>
                            </div>
                        </div>
                        <div v-if="!props.row.is_archived" class="level">
                            <div
                                class="level-item"
                                style="justify-content: space-between"
                            >
                                <b-dropdown aria-role="list">
                                    <span class="actions" slot="trigger">
                                        <button
                                            class="button"
                                            style="
                                                padding: 0 10px;
                                                font-size: 12px;
                                                color: #000;
                                            "
                                        >
                                            {{ $t("Options") }}
                                        </button>
                                    </span>
                                    <b-dropdown-item
                                        aria-role="listitem"
                                        @click="
                                            $router.push({
                                                name: 'view-order',
                                                params: {
                                                    id: props.row.id,
                                                },
                                            })
                                        "
                                    >
                                        <span class="actions dropdown-icons">
                                            <img
                                                style="
                                                    width: 20px;
                                                    margin: 0 4px;
                                                "
                                                src="@/assets/images/view.svg"
                                            />
                                        </span>
                                        <span>{{ $t("View Order") }}</span>
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="props.row.status.label == 'Draft'"
                                        aria-role="listitem"
                                        @click="editShipment(props.row.id)"
                                    >
                                        <span>
                                            <span class="dropdown-icons">
                                                <img
                                                    style="
                                                        width: 20px;
                                                        margin: 0 4px;
                                                    "
                                                    src="@/assets/images/edit.svg"
                                                />
                                            </span>
                                            {{ $t("Edit shipment") }}
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        aria-role="listitem"
                                        @click="
                                            editShipment(props.row.id, true)
                                        "
                                    >
                                        <span>
                                            <span class="dropdown-icons">
                                                <img
                                                    style="
                                                        width: 20px;
                                                        margin: 0 4px;
                                                    "
                                                    src="@/assets/images/copy.svg"
                                                />
                                            </span>
                                            {{ $t("Copy shipment") }}
                                        </span>
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        aria-role="listitem"
                                        v-if="props.row.waybill_path"
                                        @click="
                                            downloadPdfFile(
                                                props.row.waybill_path,
                                                props.row.id,
                                                API.generateWayBill
                                            )
                                        "
                                    >
                                        <span>
                                            <span class="dropdown-icons">
                                                <b-icon
                                                    icon="printer"
                                                    type="is-light"
                                                ></b-icon>
                                            </span>
                                            {{ $t("Print labels") }}
                                        </span>
                                    </b-dropdown-item>
                                    <!-- <b-dropdown-item
                                        class="LGOnly"
                                        aria-role="listitem"
                                        v-if="props.row.commercial_invoice_path"
                                        @click="
                                            downloadPdfFile(
                                                props.row
                                                    .commercial_invoice_path,
                                                props.row.id,
                                                API.generateCommercialInvoice
                                            )
                                        "
                                    >
                                        <span>
                                            <span class="dropdown-icons">
                                                <b-icon
                                                    icon="printer"
                                                    type="is-light"
                                                ></b-icon>
                                            </span>
                                            {{ $t("Print custom invoice") }}
                                        </span>
                                    </b-dropdown-item> -->
                                    <!-- <b-dropdown-item
                                        class="LGOnly"
                                        aria-role="listitem"
                                        v-if="props.row.status.id != 2 && false"
                                    >
                                        <span>
                                            <span class="dropdown-icons">
                                                <b-icon
                                                    icon="hand-left"
                                                    type="is-light"
                                                ></b-icon>
                                            </span>
                                            {{ $t("File a claim") }}
                                        </span>
                                    </b-dropdown-item> -->

                                    <!-- <b-dropdown-item
                                        v-if="
                                            props.row.status.id == 13 &&
                                            !props.row.is_picked
                                        "
                                        aria-role="listitem"
                                        @click="pickup(props.row.id)"
                                    >
                                        <span>
                                            <span class="dropdown-icons">
                                                <img
                                                    style="
                                                        width: 20px;
                                                        margin: 0 4px;
                                                    "
                                                    src="@/assets/images/pickup.svg"
                                                />
                                            </span>
                                            {{ $t("Schedual pickup") }}
                                        </span>
                                    </b-dropdown-item> -->
                                </b-dropdown>

                                <b-tooltip
                                    v-if="
                                        props.row.status.label != 'Draft' &&
                                        false
                                    "
                                    :label="$t('Whats app')"
                                    type="is-light"
                                >
                                    <span
                                        class="actions"
                                        @click="
                                            $router.push({
                                                name: 'view-order',
                                                params: {
                                                    id: props.row.id,
                                                },
                                            })
                                        "
                                    >
                                        <img
                                            src="@/assets/images/whatsapp.svg"
                                        />
                                    </span>
                                </b-tooltip>
                                <div
                                    class="msg"
                                    v-if="
                                        props.row.status.id == 13 &&
                                        !props.row.is_picked &&
                                        showSchedualMsg
                                    "
                                >
                                    <p>{{ $t("Schedual pickup now") }}</p>
                                </div>

                                <button
                                    @click="
                                        payNow(props.row.id, props.row.hash)
                                    "
                                    v-if="props.row.status.label == 'Draft'"
                                    class="button payNow"
                                >
                                    {{ $t("Pay now") }}
                                </button>
                            </div>
                        </div>
                    </b-table-column>
                </template>
                <template slot="detail" slot-scope="props">
                    <div style="display: flex">
                        <div style="margin: 0 15px">
                            <h5 style="font-weight: bold; color: #686868">
                                {{ $t("Origin") }}
                            </h5>
                            <div class="td-spacer deploy">
                                <div class="areas">
                                    <div class="name">
                                        {{
                                            `${props.row.origin.first_name} ${props.row.origin.last_name}`
                                        }}
                                    </div>
                                    <div class="address">
                                        {{
                                            `${props.row.origin.city}, ${props.row.origin.country.name}`
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin: 0 15px">
                            <h5 style="font-weight: bold; color: #686868">
                                {{ $t("Destination") }}
                            </h5>
                            <div class="td-spacer">
                                <div class="areas">
                                    <div class="name">
                                        {{
                                            `${props.row.destination.first_name} ${props.row.destination.last_name}`
                                        }}
                                    </div>
                                    <div class="address">
                                        {{
                                            `${props.row.destination.city}, ${props.row.destination.country.name}`
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="margin: 0 15px">
                            <h5 style="font-weight: bold; color: #686868">
                                {{ $t("Reference number") }}
                            </h5>
                            <div class="td-spacer">
                                <div class="areas">
                                    <div class="name">
                                        {{
                                            props.row.customer_reference || "-"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </b-table>
            <div
                v-if="shipments && !shipments.length"
                style="text-align: center; margin-top: 40px"
            >
                <p style="font-size: 20px; color: #aaa">
                    {{ $t("There is no Result") }}
                </p>
            </div>
        </div>

        <div style="display: none">
            <div id="pdf">
                <myshipmentpdf :checkedRows="checkedRows" />
            </div>
        </div>
        <b-modal
            :active.sync="isPickupOpen"
            trap-focus
            aria-role="dialog"
            aria-modal
            scroll="clip"
        >
            <pickup :orders="orders" />
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";
import myshipmentpdf from "@/components/myshipmentPDF";
import { http, API } from "@/store/API";
import { downladFileMixin } from "@/components/Mixins/downloadFileMixin";
import pickup from "@/components/modal/pickup.vue";

export default {
    name: "my-shipments",
    mixins: [downladFileMixin],
    components: {
        pickup,
        myshipmentpdf,
    },
    data() {
        return {
            filter: {
                status: 0,
                vendor: 0,
                is_archived: 0,
            },
            printOptions: {
                id: "pdf",
                popTitle: "",
            },
            search: "",
            timeoutID: null,
            checkedRows: [],
            matchState: 0,
            orders: [],
            filterdShipment: [],
            isPickupOpen: false,
            loading: false,
            showSchedualMsg: true,
            API,
            perPage: 10,
            json_fields: {
                [this.$t("Order number")]: "order_number",
                [this.$t("Date")]: {
                    field: "created_at",
                    callback: (value) => {
                        return moment(value).format("DD-MM-YYYY");
                    },
                },
                [this.$t("Service Provider")]: "vendor_name",
                [this.$t("Tracking Number")]: "vendor_shipment_id",
                [this.$t("Total Weight") + " " + this.$t("KG")]: {
                    field: "total_weight",
                    callback: (value) => {
                        return value.toFixed(1);
                    },
                },
                [this.$t("Amount") + " " + this.$t("SAR")]: {
                    field: "total_price",
                    callback: (value) => {
                        return value.toFixed(2);
                    },
                },
                [this.$t("Status")]: {
                    field: "status.label",
                    callback: (value) => {
                        return this.$t(value);
                    },
                },
            },
            json_meta: [
                [
                    {
                        key: "charset",
                        value: "utf-8",
                    },
                ],
            ],
        };
    },
    watch: {
        checkedRows: {
            immediate: true,
            handler(val) {
                this.matchState = 0;
                this.orders = [];
                if (!val || !val.length) return;
                let origin_id = val[0].origin.id;
                let destination_id = val[0].destination.id;
                val.map((row) => {
                    if (
                        row.origin.id != origin_id ||
                        row.destination.id != destination_id ||
                        row.status.id != 2 ||
                        row.is_picked
                    )
                        return this.matchState++;
                });
                if (this.matchState > 0) return;
                val.reduce((a, b) => {
                    this.orders.push(b.id);
                }, this.orders);
            },
        },
        search: {
            immediate: true,
            handler(val) {
                if (val) {
                    clearTimeout(this.timeoutID);
                    this.timeoutID = setTimeout(() => {
                        this.$store
                            .dispatch(
                                "userShipment",
                                `?search=${val}&is_archived=0`
                            )
                            .then(() => {
                                this.loading = false;
                            });
                    }, 1000);

                    // let query = new RegExp(val, "i");
                    // this.filterdShipment = this.shipments.filter((shipment) =>
                    //     query.test(`${shipment.id} ${shipment.order_id}`)
                    // );
                } else {
                    this.filterdShipment = this.shipments;
                }
            },
        },
        shipments: {
            immediate: true,
            handler(val) {
                if (!val || !val.length) return;
                this.loading = false;
                this.filterdShipment = val;
            },
        },
        filter: {
            immediate: true,
            deep: true,
            handler(val) {
                this.filterShipment(null);
            },
        },
    },
    methods: {
        filterShipment(page) {
            this.loading = true;
            let filterString = `?is_archived=${this.filter.is_archived}${
                this.filter.vendor ? "&vendor=" + this.filter.vendor : ""
            }${this.filter.status ? "&status=" + this.filter.status : ""}${
                page ? "&page=" + page : ""
            }`;
            this.$store.dispatch("userShipment", filterString).then(() => {
                this.loading = false;
            });
        },
        tracking(vendor, id) {
            switch (vendor) {
                case "DHL":
                    window.open(
                        `https://www.dhl.com.sa/en/express/tracking.html?AWB=${id}&brand=DHL`,
                        "_blank"
                    );
                    break;
                case "FedEx":
                    window.open(
                        `https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=${id}&cntry_code=us&locale=en_US`,
                        "_blank"
                    );
                    break;
                default:
                    window.open(
                        "https://support.wwf.org.uk/earth_hour/index.php?type=individual",
                        "_blank"
                    );
            }
        },
        checkState() {
            let ids = this.checkedRows.reduce((a, b) => {
                a.push(b.id);
                return a;
            }, []);
        },

        checkShipment() {
            let matchState = 0;
            if (!this.checkedRows || !this.checkedRows.length) return;
            let origin_id = this.checkedRows[0].origin.id;
            let destination_id = this.checkedRows[0].destination.id;
            this.checkedRows.map((row) => {
                if (
                    row.origin.id != origin_id ||
                    row.destination.id != destination_id ||
                    row.status.id != 13 ||
                    row.is_picked
                )
                    return matchState++;
            });
            if (matchState > 0) return false;
            return true;
        },
        pickup(id) {
            this.orders = [];
            this.orders.push(id);
            this.isPickupOpen = true;
        },
        payNow(id, hash) {
            this.loading = true;
            this.$store.dispatch("restoreShipment", { id }).then((res) => {
                this.loading = false;
                this.$router.push("/checkout/" + hash);
            });
        },
        editShipment(id) {
            this.loading = true;
            this.$store
                .dispatch("restoreShipment", { id, copyShipment: true })
                .then((res) => {
                    this.loading = false;
                    this.$router.push("/send-shipment");
                });
        },
        // addComma(s) {
        //     if (s.length > 3) {
        //         return `${s.slice(0, -3)},${s.slice(-3)}`;
        //     } else {
        //         return s;
        //     }
        // },
        // calcTotalPrice(price) {
        //     var priceSplit = String(price).split(".")[0];
        //     var priceSplitSecond = String(price).split(".")[1];

        //     return `${this.addComma(priceSplit)}${
        //         priceSplitSecond ? "." + priceSplitSecond : ""
        //     }`;
        // },
    },
    computed: {
        shipments() {
            return this.$store.state.userShipments.data;
        },
        total() {
            return this.$store.state.userShipments.total;
        },
    },
    created() {
        if (Object.keys(this.$route.query).length) {
            this.$store
                .dispatch("store_transaction", this.$route.query)
                .then((res) => {
                    let url = document.location.href;
                    window.history.pushState({}, "", url.split("?")[0]);
                });
        }
    },
    mounted() {
        this.loading = true;
        this.$store.dispatch("userShipment", "?is_archived=0").then(() => {
            this.loading = false;
        });
        setTimeout(() => {
            this.showSchedualMsg = false;
        }, 5000);
        this.$store.dispatch("resetSession");
        this.$store.dispatch("address", null);
    },
};
</script>

<style lang="scss" scoped>
.user-shipment {
    .mobile-send-shipment {
        background: #ffd833 !important;
        color: #000;
        display: none;
        box-shadow: 1px 1px 5px #ffd833;
        border-color: #ffd833 !important;
        letter-spacing: 1px;
        font-size: 19px;
        padding: 5px 30px;
        @media screen and (max-width: 700px) {
            display: block;
        }
    }
}
.payNow {
    font-size: 12px;
    background: #fff !important;
    color: #000 !important;

    &:hover {
        background: #000 !important;
        border: none !important;
        color: white !important;
    }
}

.filter-sec {
    padding: 0 50px;

    .b-checkbox {
        opacity: 1 !important;
    }
}

.msg {
    background: #ff7977;
    padding: 2px 10px;
    color: #000;
    font-size: 12px;
    border-radius: 7px;
}

.card-head {
    display: flex;
    padding-top: 30px;

    div {
        display: flex;
        align-items: center;

        &.l-sec {
            width: 50%;
            justify-content: center;

            input {
                background: #f7f7f7;
                width: 75%;
                padding: 16px 50px;
                border-radius: 50px;
                outline: none;
                font-size: 18px;
                font-weight: bold;
                color: #444;
                letter-spacing: 0.7px;

                &::placeholder {
                    &::placeholder {
                        color: #444;
                        font-size: 14px;
                        font-weight: lighter !important;
                    }
                }
            }
        }

        &.r-sec {
            width: 50%;

            button {
                margin: 0 10px;
                height: 27px;
                width: 130px;
                border-radius: 7px;
            }
        }
    }
}

.level {
    height: 50px !important;
    padding-bottom: 0 !important;

    .view-order {
        font-size: 0.78rem;
        display: inline-block;
        text-align: center;
        background-color: #93a2dd;
        color: white;
        padding: 2px 4px;
        margin-right: 15px;
        cursor: pointer;
        border-radius: 5px;

        &:hover {
            background-color: #5d78ff !important;
        }
    }
}

.td-spacer {
    padding: 5px 0;
}

.areas {
    .address {
        color: #737373;
        text-transform: capitalize;
        font-size: 0.85rem;
    }
}

.status {
    font-size: 0.78rem;
    display: inline-block;
    background-color: #f2f2f2;
    color: #000;
    padding: 3px 10px;
    border-radius: 50px;

    &.st-Waiting {
        background: #ff797798;
    }

    &.st-Pending {
        background: #5d78ff70;
    }

    &.st-Reviewing {
        background: #ffcf2159;
    }

    &.st-In-transit {
        background: #37d5b038;
    }

    &.st-Delivered {
        background: #50e3c2;
    }

    &.st-Canceled {
        background: #000;
        color: white;
    }
}

// .table td {
//     border-top: 2px solid #f7f8fa !important;
// }

::v-deep {
    .b-table .table tr.detail {
        box-shadow: none !important;
        background: #fafafa;
    }

    .table {
        margin-top: 40px;
        padding: 0 5px !important;

        table {
            width: 100%;

            thead {
                background: #f7f7f7;
                border-radius: 5px;
            }

            th {
                padding-top: 11px;
                padding-bottom: 11px;
            }

            tbody {
                tr {
                    border-bottom: 1px solid #ddd;
                    height: 60px;
                    // &:last-of-type {
                    //     border: none;
                    // }

                    td {
                        border-bottom: 2px solid #f7f8fa !important;
                        vertical-align: middle;
                    }
                }
            }

            .total {
                font-weight: bold;
                text-align: center;
            }

            .primary {
                color: #4952ff;
                font-weight: bold;
            }

            .danger {
                color: #ff7977;
                font-weight: bold;
            }

            .text-center {
                text-align: center;
            }
        }
    }
}

.actions {
    color: #93a2dd;
    display: inline-block;
    margin-right: 5px;
    margin-left: 5px;
    cursor: pointer;

    i {
        color: #93a2dd !important;
    }

    &:hover {
        color: #555 !important;
    }
}

.dropdown-icons {
    margin-right: 15px;
    display: inline-block;
}

@media screen and (max-width: 1000px) {
    .card-head {
        flex-wrap: wrap;

        div {
            &.l-sec {
                width: 100%;

                input {
                    width: 95%;
                    font-size: 16px;
                }
            }

            &.r-sec {
                display: none;
            }
        }
    }

    .filter-sec {
        padding: 10px 0 !important;
    }

    .LGOnly {
        display: none !important;
    }
}
</style>
